<template>
    <!-- Info to scan code -->
    <div v-if="!scannedCode" class="col-12">
        <div class="alert alert-info text-white text-center" role="alert">
            <strong>დაასკანერეთ</strong> ფასდაკლების ბარათის
            <strong>QR კოდი</strong>
        </div>
    </div>
    <!-- Code scanner cam -->
    <div v-if="!scannedCode && !error" class="col-12">
        <qrcode-stream
            @detect="handleQrScan"
            @error="handleQrError"
        ></qrcode-stream>
    </div>
    <!-- Scanned code details -->
    <div v-if="scannedCode && result && !error" class="col-12">
        <div class="row">
            <!-- Qr code -->
            <div class="col-12">
                <div
                    class="alert alert-info text-white text-center"
                    role="alert"
                >
                    <div class="text-center mb-2">
                        <img
                            class="text-center"
                            :src="`https://intranet.infoajara.com/storage/qrcodes/${scannedCode}.svg`"
                            alt="QR კოდი"
                        />
                    </div>
                    დასკანერებული კოდი: <strong>{{ scannedCode }}</strong>
                </div>
            </div>
            <!-- Card validity -->
            <div v-if="scannedCode && result" class="col-12">
                <div
                    class="alert text-white text-center"
                    :class="cardStatus ? 'alert-success' : 'alert-danger'"
                    role="alert"
                >
                    {{
                        cardStatus ? "ბარათი ვალიდურია" : "ბარათი არაა ვალიდური"
                    }}
                </div>
            </div>
            <!-- Add card visit -->
            <div v-if="scannedCode && result && cardStatus" class="col-12">
                <button
                    type="button"
                    @click="
                        addCardVisit(
                            result?.realization?.client?.id,
                            company_id
                        )
                    "
                    class="btn btn-lg btn-primary w-100"
                >
                    ვიზიტის დაფიქსირება
                </button>
            </div>
            <!-- Not sold yet -->
            <div v-if="!result.realization" class="col-12">
                <div
                    class="alert alert-warning text-white text-center"
                    role="alert"
                >
                    ბარათი ჯერ არ გაყიდულა.
                </div>
            </div>
            <!-- Card details -->
            <div v-if="result?.realization" class="col-12 mb-3">
                <div class="card shadow-0">
                    <div class="card-header p-2">
                        <h6 class="mb-0">ბარათის დეტალები</h6>
                    </div>
                    <div class="card-body p-2">
                        <p class="mb-0">
                            <small>
                                <strong>დაწყების თარიღი:</strong>
                                {{
                                    moment(
                                        result?.realization?.start_date
                                    ).format("DD-MM-YYYY")
                                }}
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ვალიდურია:</strong>
                                {{
                                    moment(
                                        result?.realization?.end_date
                                    ).format("DD-MM-YYYY")
                                }}
                                -მდე
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ტიპი:</strong>
                                {{ result?.realization?.type?.type?.title }}
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ფასი:</strong>
                                {{
                                    `${(result?.realization?.type?.type?.price).toFixed(
                                        2
                                    )}₾`
                                }}
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ხანგრძლივობა:</strong>
                                {{ result?.realization?.type?.type?.duration }}
                                დღე
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>მრავალჯერადი:</strong>
                                {{
                                    result?.realization?.type?.type?.is_multiple
                                        ? "კი"
                                        : "არა"
                                }}
                            </small>
                        </p>
                    </div>
                </div>
            </div>
            <!-- Client details -->
            <div v-if="result?.realization" class="col-12 mb-3">
                <div class="card shadow-0">
                    <div class="card-header p-2">
                        <h6 class="mb-0">კლიენტის დეტალები</h6>
                    </div>
                    <div class="card-body p-2">
                        <p class="mb-0">
                            <small>
                                <strong>სახელი და გვარი:</strong>
                                {{
                                    `${result?.realization?.client?.first_name} ${result?.realization?.client?.last_name}`
                                }}
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ტელეფონი: </strong>
                                <a
                                    :href="`tel:${result?.realization?.client?.phone}`"
                                >
                                    {{ result?.realization?.client?.phone }}
                                </a>
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ელ-ფოსტა: </strong>
                                <a
                                    :href="`mailto:${result?.realization?.client?.email}`"
                                >
                                    {{ result?.realization?.client?.email }}
                                </a>
                            </small>
                        </p>
                        <p class="mb-0">
                            <small>
                                <strong>ქვეყანა:</strong>
                                {{ result?.realization?.client?.country?.name }}
                            </small>
                        </p>
                    </div>
                </div>
            </div>
            <!-- Card visits -->
            <div v-if="visits && visits.length > 0" class="col-12 mb-3">
                <div class="card shadow-0">
                    <div class="card-header p-2">
                        <h6 class="mb-0">ქარდის ვიზიტები</h6>
                    </div>
                    <div class="card-body p-2">
                        <p v-for="visit in visits" :key="visit.id" class="mb-0">
                            <small>
                                <strong>{{ visit?.company?.name }}</strong>
                                {{
                                    moment(visit?.created_at).format(
                                        "H:mm, DD-MM-YYYY"
                                    )
                                }}
                            </small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Error details -->
    <div v-if="error" class="col-12">
        <div class="alert alert-danger text-white" role="alert">
            {{ error }}
        </div>
    </div>
    <!-- Reset button -->
    <div v-if="scannedCode || error" class="col-12">
        <button
            type="button"
            @click="reset"
            class="btn btn-lg btn-primary w-100"
        >
            თავიდან დასკანერება
        </button>
    </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import moment from "moment";

const baseURL = "/api/bcard";

export default {
    components: {
        QrcodeStream,
    },
    data() {
        return {
            moment,
            scannedCode: null,
            error: null,
            loading: false,
            token: null,
            company_id: null,
            result: null,
            visits: [],
        };
    },
    computed: {
        isValid() {
            return moment() <= moment(this.result?.realization?.end_date);
        },
        alreadyVisited() {
            return this.visits && this.visits.length > 0;
        },
        cardStatus() {
            return this.isValid && !this.alreadyVisited;
        },
    },
    methods: {
        handleQrScan(detectedCodes) {
            detectedCodes.map((code) => {
                this.scannedCode = code.rawValue;

                this.getCardData(code.rawValue);

                if (this.company_id) {
                    this.getVisits(code.rawValue, this.company_id);
                }
            });
        },
        handleQrError(error) {
            this.error =
                typeof error === "string" ? error : JSON.stringify(error);
        },
        async getCardData(qr) {
            this.loading = true;

            try {
                const options = {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.token}`,
                    },
                };

                const res = await fetch(
                    `${baseURL}/cards?${new URLSearchParams({ qr })}`,
                    options
                );

                if (!res.ok) {
                    throw new Error(
                        "ფასდაკლების ბარათის დეტალები ვერ მოიძებნა. დაასკანერეთ QR კოდი თავიდან."
                    );
                }

                const data = await res.json();
                this.result = data[0];
            } catch (error) {
                console.log(error);
                this.handleQrError(error.message);
            } finally {
                this.loading = true;
            }
        },
        async getVisits(qr, company_id) {
            this.loading = true;

            try {
                const options = {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.token}`,
                    },
                };

                const res = await fetch(
                    `${baseURL}/cards/visits?${new URLSearchParams({
                        qr,
                        company_id,
                    })}`,
                    options
                );

                if (!res.ok) {
                    throw new Error(
                        "ფასდაკლების ბარათის ვიზიტები ვერ მოიძებნა. დაასკანერეთ QR კოდი თავიდან."
                    );
                }

                const data = await res.json();
                this.visits = data;
            } catch (error) {
                console.log(error);
                this.handleQrError(error.message);
            } finally {
                this.loading = true;
            }
        },
        async addCardVisit(client_id, company_id) {
            this.loading = true;

            try {
                const csrfToken = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");

                const options = {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": csrfToken,
                        Authorization: `Bearer ${this.token}`,
                    },
                    body: JSON.stringify({ client_id, company_id }),
                };

                const res = await fetch(`${baseURL}/cards/visits`, options);

                if (res.status !== 201) {
                    throw new Error(
                        "ვიზიტის დაფიქსირება ვერ მოხერხდა, მოგვიანებით სცადეთ."
                    );
                } else {
                    Swal.fire({
                        title: "ვიზიტი დაფიქსირებულია",
                        icon: "success",
                        draggable: false,
                        showCloseButton: true,
                        confirmButtonText: "დახურვა",
                    });

                    this.getCardData(this.scannedCode);
                    this.getVisits(this.scannedCode, this.company_id);
                }
            } catch (error) {
                console.log(error);
                this.handleQrError(error.message);
            } finally {
                this.loading = true;
            }
        },
        getBearerToken() {
            const meta = document.querySelector('meta[name="bearer_token"]');

            if (meta) {
                this.token = meta.content;
            }
        },
        getCompanyId() {
            const meta = document.querySelector('meta[name="company_id"]');

            if (meta) {
                this.company_id = meta.content;
            }
        },
        reset() {
            this.scannedCode = null;
            this.error = null;
            this.loading = false;
            this.result = null;
            this.visits = [];
        },
    },
    mounted() {
        this.getBearerToken();
        this.getCompanyId();
    },
};
</script>

<style>
.swal2-title {
    font-size: 20px !important;
}
</style>
